import React, { useEffect } from "react"

function Social(props) {
  useEffect(() => {document.title = props.title})
  
  return (
    <main id="main-content">
    <h1>{props.title}</h1>
      
      <div id="social">
        <h2>Follow Me</h2>
        <p>You can find me on YouTube at</p>
        <a href="https://www.youtube.com/user/least1234/">https://www.youtube.com/user/least1234/</a>
      </div>
    </main>
  )
}

export default Social